import React from 'react'
import { get } from 'lodash'
import { Redirect } from 'react-router-dom'

import config from 'config'
import { NextLevel as NextLevelPage } from 'containers/pages/register'
import * as NextLevel from 'containers/forms/nextLevel'

const urlPrefix = `${config.publicPath}/register/next-level`

export default [
  {
    path: `${urlPrefix}`,
    component: props => (
      <NextLevelPage logout {...props} />
    ),
    routes: [
      {
        path: `${urlPrefix}`,
        exact: true,
        component: props => (
          <Redirect to={{
            pathname: `${config.publicPath}/register/next-level/welcome`,
            search: get(props, 'location.search')
          }}
          />
        ),
        routes: []
      },
      {
        path: `${urlPrefix}/welcome`,
        exact: true,
        component: props => (
          <NextLevel.Welcome {...props} />
        ),
        activeId: 1,
        routes: []
      },
      {
        path: `${urlPrefix}/level`,
        exact: true,
        component: props => (
          <NextLevel.Level {...props} />
        ),
        activeId: 2,
        routes: []
      },
      {
        path: `${urlPrefix}/contacts`,
        exact: true,
        component: props => (
          <NextLevel.Contacts {...props} />
        ),
        activeId: 3,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/details`,
        exact: true,
        component: props => (
          <NextLevel.Details {...props} />
        ),
        activeId: 4,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/parent`,
        exact: true,
        component: props => (
          <NextLevel.Parent {...props} />
        ),
        activeId: 5,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/profile`,
        exact: true,
        component: props => (
          <NextLevel.Profile {...props} />
        ),
        activeId: 6,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/payment`,
        exact: true,
        component: props => (
          <NextLevel.Payment {...props} />
        ),
        activeId: 7,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/privacy-policy`,
        exact: true,
        component: props => (
          <NextLevel.PrivacyPolicy {...props} />
        ),
        activeId: 8,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/success`,
        exact: true,
        component: props => (
          <NextLevel.Success {...props} />
        ),
        activeId: 9,
        hideLocaleSwitcher: true,
        routes: []
      }
    ]
  }
]
